/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { IMedia } from '../../media/media-schema';
import { mediaSchema } from '../../media/media-schema';

export const uploadCollectionMediaResponseSchema = createApiResponseSchema(
  mediaSchema,
) as import('zod').ZodSchema<IAPI<IMedia>>;

export type IUploadCollectionMediaResponse = IAPI<IMedia>;
